export const properties = [
  {
    id: "ams-01",
    title: "Licht studio-appartement",
    city: "Amsterdam Nieuw-West",
    price: 875,
    rooms: 1,
    area: 38,
    available: "Per 1 augustus",
    image:
      "https://images.pexels.com/photos/38354520/pexels-photo-38354520.jpeg?auto=compress&cs=tinysrgb&w=1200",
    aspect: "aspect-[4/5]",
  },
  {
    id: "rtm-02",
    title: "Hoekappartement met balkon",
    city: "Rotterdam Zuid",
    price: 3600,
    rooms: 3,
    area: 72,
    available: "Per direct",
    image:
      "https://images.unsplash.com/photo-1738168246881-40f35f8aba0a?auto=format&fit=crop&w=1200&q=80",
    aspect: "aspect-[4/3]",
  },
  {
    id: "utr-03",
    title: "Minimalistisch appartement",
    city: "Utrecht Overvecht",
    price: 995,
    rooms: 2,
    area: 55,
    available: "Per 15 augustus",
    image:
      "https://images.unsplash.com/photo-1774716925810-e923c8206ed5?auto=format&fit=crop&w=1200&q=80",
    aspect: "aspect-[4/5]",
  },
  {
    id: "ein-05",
    title: "Sfeervol appartement centrum",
    city: "Eindhoven Strijp",
    price: 925,
    rooms: 2,
    area: 61,
    available: "Per direct",
    image:
      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1200&q=80",
    aspect: "aspect-[4/5]",
  },
  {
    id: "gro-06",
    title: "Compacte studio nabij station",
    city: "Groningen Binnenstad",
    price: 795,
    rooms: 1,
    area: 34,
    available: "Per 1 augustus",
    image:
      "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1200&q=80",
    aspect: "aspect-[4/3]",
  },
];
